module.exports = __webpack_public_path__ + "static/media/1.278aa6f9.png";